<template>
  <div>
    <template v-show="uid">
      <navigation></navigation>
      <v-content>
        <dash v-if="dashboard" />
        <router-view v-else></router-view>
      </v-content>
      <!-- <v-footer color="amber darken-1" app>
                <span class="white--text">&copy; 2018</span>
            </v-footer> -->
    </template>
    <template v-if="!uid">
      <Login />
    </template>
  </div>
</template>

<script>
import Navigation from "./modules/admin-navigation";
import Login from "./login";
import Dash from "@/components/pages/Dash";
export default {
  name: "AdminDashboard",
  components: {
    Navigation,
    Login,
    Dash
  },
  data() {
    return {};
  },
  watch: {
    /* uid(newUid, oldUid) {
            if (newUid && !oldUid) {
                this.setEventosUser()
            }
        } */
  },
  created() {
    this.setEstadisticas();
    this.setUsers();
    this.setUsuario();
    this.setUsersPreReg();
    this.setExpedientes();
    this.setCatastro();
    this.setExpedientesStatus();
    this.setProvincias();
    this.setComunidades();
    this.setEventosGlobal();
    this.setEventosUser();
  },
  computed: {
    uid() {
      return this.$store.getters.getUserUid;
    },
    usuario() {
      return this.$store.getters.getUsuarioAdmin;
    },
    eventosUser() {
      return this.$store.getters.getEventosUser;
    },
    eventosGlobal() {
      return this.$store.getters.getEventosGlobal;
    },
    dashboard() {
      return this.$route.fullPath === "/dashboard";
    }
  },
  methods: {
    setEventosUser() {
      this.$store.dispatch("setEventosUser");
    },
    setEventosGlobal() {
      this.$store.dispatch("setEventosGlobal");
    },
    setUsers() {
      this.$store.dispatch("setUsers");
    },
    setUsuario() {
      this.$store.dispatch("setUsuario");
    },
    setUsersPreReg() {
      this.$store.dispatch("setUsersPreReg");
    },
    setExpedientes() {
      this.$store.dispatch("setExpedientes");
    },
    setExpedientesStatus() {
      this.$store.dispatch("setExpedientesStatus");
    },
    setCatastro() {
      this.$store.dispatch("setCatastro");
    },
    setProvincias() {
      this.$store.dispatch("setProvincias");
    },
    setComunidades() {
      this.$store.dispatch("setComunidades");
    },
    setEstadisticas() {
      this.$store.dispatch("setEstadisticasExpedientes");
      this.$store.dispatch("setEstadisticasCatastro");
    }
  }
};
</script>
